var Actions;
(function (Actions) {
    Actions["GET_DIRECTORATE_LIST"] = "getDirectorateList";
    Actions["GET_DIRECTORATE_LIST_ALLDATA"] = "getDirectorateListAllData";
    Actions["UPDATE_DIRECTORATE_PAGE_FILTER"] = "updateDirectoratePageFilter";
    Actions["UPDATE_DIRECTORATE_SIZE"] = "updateDirectorateSize";
    Actions["UPDATE_DIRECTORATE_CODE"] = "updateDirectorateCode";
    Actions["UPDATE_DIRECTORATE_DESC"] = "updateDirectorateDesc";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    // directorate for menu mapping project
    Mutations["SET_DIRECTORATE_LOAD"] = "setDirectorateWasFirstLoad";
    Mutations["SET_DIRECTORATE_LIST"] = "setDirectorateList";
    Mutations["SET_DIRECTORATE_HANDLE_PAGE"] = "setDirectorateHandlePage";
    Mutations["SET_DIRECTORATE_PAGE"] = "setDirectoratePage";
    Mutations["SET_DIRECTORATE_LOAD_PAGE"] = "setDirectorateLoadPage";
    Mutations["SET_DIRECTORATE_LOADING"] = "setDirectorateLoading";
    Mutations["SET_DIRECTORATE_STATUS"] = "setDirectorateStatus";
    Mutations["SET_SELECTED_DIRECTORATE_NAME"] = "setSelectedDirectorateName";
    Mutations["SET_DROPDOWNLIST_DIRECTORATE_CODE"] = "setDropdownlistDirectorateCode";
    Mutations["SET_DROPDOWNLIST_DIRECTORATE_NAME"] = "setDropdownlistDirectorateName";
    Mutations["SET_DIRECTORATE_SIZE"] = "setDirectorateSize";
    Mutations["SET_DIRECTORATE_HANDLE_SIZE"] = "setDirectorateHandleSize";
    Mutations["SET_DIRECTORATE_PAGE_FILTER"] = "setDirectoratePageFilter";
    Mutations["SET_DIRECTORATE_WAS_LOAD_QUICK_FILTER"] = "setDirectorateWasLoadQuickFilter";
    Mutations["SET_DIRECTORATE_DESC"] = "setDirectorateSelectedDesc";
    Mutations["SET_DIRECTORATE_SEARCH_BY"] = "setDirectorateSelectedSearchBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
